import * as React from 'react'
import { connect } from 'react-redux'
import { CallAnalytics } from './CallAnalytics'
import { get, flow } from 'lodash'
import { replace } from 'react-router-redux/lib'
import { reduxForm } from 'redux-form'
import { getCallUsage, getNumbersAnalytics } from 'features/Numbers/Numbers.actions'
import { showAnalyticsShareModal } from 'features/CallAnalytics/AnalyticsShareModal'

const formName = 'callAnalytics'

export interface ICallAnalyticsContainerProps {
  location: {
    pathname: string
    query: {
      page: string
      serviceIds?: string
      token?: string
    }
  }
}

const stateToProps = ({ numbers, form }, { location: { query } }: ICallAnalyticsContainerProps) => {
  const formData = get(form, [formName, 'values'], {})
  const limit = 11000
  const serviceIds = query.serviceIds ? query.serviceIds.split('-') : []
  const page = parseInt(query.page, 10) || 1
  const cacheKey = `${query.serviceIds}-${page}-${limit}`
  const callUsage = get(numbers, ['callUsage', cacheKey], {})
  return {
    services: numbers.numbersAnalytics,
    servicesLoading: numbers.numbersAnalyticsLoading,
    serviceIds,
    callUsage,
    limit,
    page,
    formData,
    cacheKey,
    isDashboardPage: location.pathname.includes('/dashboard'),
    initialValues: {
      period: '1-week',
      serviceIds,
    },
  }
}

export const dispatchToProps = {
  showAnalyticsShareModal,
  getCallUsage,
  getNumbersAnalytics,
  replace,
}

export const CallAnalyticsContainer = flow<any, any, React.SFC<ICallAnalyticsContainerProps>>(
  reduxForm({ form: formName, enableReinitialize: true }),
  connect(stateToProps, dispatchToProps)
)(CallAnalytics)



// WEBPACK FOOTER //
// src/pages/CallAnalytics/CallAnalytics.container.ts